import { jsx } from "react/jsx-runtime";
import { IconButton } from "../../../Inputs/IconButton/index.js";
import { StyledPause, StyledPlay } from "./styles.js";
import { AUTOPLAY_BUTTON_PAUSE_LABEL, AUTOPLAY_BUTTON_PLAY_LABEL } from "../constants.js";
const AutoplayButton = ({
  enabled,
  handleAutoplayClick,
  isActive,
  onButtonBlur,
  onButtonFocus,
  pauseLabel = AUTOPLAY_BUTTON_PAUSE_LABEL,
  playLabel = AUTOPLAY_BUTTON_PLAY_LABEL
}) => {
  if (!enabled) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      "aria-label": isActive ? pauseLabel : playLabel,
      onBlur: onButtonBlur,
      onClick: handleAutoplayClick,
      onFocus: onButtonFocus,
      sx: {
        padding: 0,
        width: "28px",
        height: "28px"
      },
      children: isActive ? /* @__PURE__ */ jsx(StyledPause, {}) : /* @__PURE__ */ jsx(StyledPlay, {})
    }
  );
};
export {
  AutoplayButton
};
